import { supabase } from './supabase';

// Lädt ein Rechnungs-PDF aus dem privaten Storage-Bucket herunter.
// Der Zugriff wird durch Storage-RLS geprüft (eigener Schüler oder Admin).
export async function downloadInvoicePdf(pdfPath: string, invoiceNumber: string): Promise<void> {
  const { data, error } = await supabase.storage.from('invoices').download(pdfPath);
  if (error || !data) throw error ?? new Error('Download fehlgeschlagen');
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${invoiceNumber}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
